import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";

const STORAGE_KEY = "pine_journey_banner_dismissed";

export default function LegacyLeadsBanner() {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(STORAGE_KEY) === "1");
    } catch {
      setDismissed(false);
    }
  }, []);

  if (dismissed) return null;

  const onDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div
      data-testid="legacy-leads-banner"
      className="mb-6 flex flex-col gap-4 rounded-md border border-emerald-500/30 bg-emerald-500/[0.04] p-5 sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="space-y-1">
        <p className="text-sm font-semibold text-emerald-400">
          Neue CRM-Ansicht: PINE Journey Control ist vorbereitet.
        </p>
        <p className="text-sm text-muted-foreground">
          Die bisherige Lead-Ansicht bleibt bestehen. Die neue CRM-Steuerung
          entsteht schrittweise unter PINE Journey Control.
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Button
          asChild
          size="sm"
          data-testid="legacy-leads-banner-open"
          className="bg-emerald-500 text-zinc-950 hover:bg-emerald-400"
        >
          <Link to="/admin/journey/inbox">
            PINE Journey Control öffnen
            <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
          </Link>
        </Button>
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Banner schließen"
          data-testid="legacy-leads-banner-dismiss"
          className="rounded p-1.5 text-muted-foreground transition hover:bg-white/5 hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
